import React from 'react';
import { Globe2 } from 'lucide-react';

interface LoadingOverlayProps {
  city: string;
  countryName?: string;
}

export function LoadingOverlay({ city, countryName }: LoadingOverlayProps) {
  const [dots, setDots] = React.useState('');

  React.useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? '' : prev + '.');
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="absolute inset-0 bg-white/90 dark:bg-gray-800/90 backdrop-blur-md flex items-center justify-center z-10 rounded-xl">
      <div className="text-center">
        <div className="relative w-20 h-20 mx-auto mb-6">
          <div className="absolute inset-0 rounded-full border-[3px] border-gray-200 dark:border-gray-700" />
          <div className="absolute inset-0 rounded-full border-[3px] border-transparent border-t-primary-500 animate-[spin_1s_linear_infinite]" />
          <div className="absolute inset-[6px] rounded-full border-[3px] border-transparent border-b-accent-500 animate-[spin_1.5s_linear_infinite_reverse]" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary-50 to-accent-50 dark:from-primary-900/30 dark:to-accent-900/30 flex items-center justify-center">
              <Globe2 className="w-5 h-5 text-primary-500 dark:text-primary-400" />
            </div>
          </div>
        </div>

        <h3 className="text-base font-bold text-gray-900 dark:text-white mb-1.5">
          Chargement des données
        </h3>
        <p className="text-sm text-gray-500 dark:text-gray-400 max-w-[260px] mx-auto">
          Récupération des coûts pour <span className="font-semibold text-gray-700 dark:text-gray-300">{city}</span>
          {countryName && <span>, {countryName}</span>}{dots}
        </p>
      </div>
    </div>
  );
}
